var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('div', {
    staticClass: "client-content-wrap"
  }, [_c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "client-title--xxxl"
  }, [_vm._v("연혁")])]), _c('ul', {
    staticClass: "history-list"
  }, _vm._l(_vm.histories, function (history, index) {
    return _c('li', {
      key: index
    }, [_c('v-row', {
      staticClass: "row--xxl"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "6",
        "order-lg": (index + 1) % 2 !== 0 ? '2' : ''
      }
    }, [_c('v-row', {
      staticClass: "row--xs"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "client-title--xl font-weight-bold line-height-1 history-list__year"
    }, [_vm._v(" " + _vm._s(history.year) + " ")])]), _c('v-col', {
      staticClass: "page-text page-text",
      attrs: {
        "cols": "12"
      }
    }, _vm._l(history.items, function (item) {
      return _c('v-row', {
        key: item.month,
        staticClass: "row--xs"
      }, [_c('v-col', {
        attrs: {
          "cols": "auto",
          "order-lg": (index + 1) % 2 === 0 ? '2' : ''
        }
      }, [_c('v-sheet', {
        staticClass: "grey-1--text",
        attrs: {
          "width": "20"
        }
      }, [_vm._v(" " + _vm._s(item.month) + " ")])], 1), _c('v-col', [_c('v-row', {
        staticClass: "row--xs"
      }, _vm._l(item.contents, function (content) {
        return _c('v-col', {
          key: content,
          attrs: {
            "cols": "12"
          }
        }, [_c('v-row', {
          staticClass: "ma-n2"
        }, [_c('v-col', {
          staticClass: "pa-2",
          attrs: {
            "cols": "auto",
            "order-lg": (index + 1) % 2 === 0 ? '2' : ''
          }
        }, [_vm._v("·")]), _c('v-col', {
          staticClass: "pa-2"
        }, [_vm._v(" " + _vm._s(content) + " ")])], 1)], 1);
      }), 1)], 1)], 1);
    }), 1)], 1)], 1), _c('v-col', {
      attrs: {
        "cols": "12",
        "lg": "6"
      }
    }, [history.images ? _c('v-row', _vm._l(history.images, function (image) {
      return _c('v-col', {
        key: image,
        attrs: {
          "cols": "6",
          "lg": "12"
        }
      }, [_c('v-img', {
        staticClass: "history-list__image",
        attrs: {
          "src": image,
          "max-width": "384",
          "alt": ""
        }
      })], 1);
    }), 1) : _vm._e()], 1)], 1)], 1);
  }), 0)])], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }